import type { Breadcrumb, ErrorEvent } from "@sentry/types"

const REDACTED = "[redacted]"
const TOKEN_KEYS = new Set(["sessionToken", "sessionTokenHash", "deviceToken", "spectatorToken"])
const SECRET_GAME_KEYS = new Set(["topic", "topicTitle", "topicAliases", "clue", "clueText", "vote"])

export function sanitizeSentryEvent(event: ErrorEvent) {
  return sanitizeValue(event) as ErrorEvent
}

export function sanitizeSentryBreadcrumb(breadcrumb: Breadcrumb) {
  return sanitizeValue(breadcrumb) as Breadcrumb
}

function sanitizeValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map((entry) => sanitizeValue(entry))
  }

  if (!value || typeof value !== "object") {
    return value
  }

  const entries = Object.entries(value as Record<string, unknown>).map(([key, entry]) => {
    if (TOKEN_KEYS.has(key) || SECRET_GAME_KEYS.has(key)) {
      return [key, REDACTED] as const
    }

    if (key === "playerId" && typeof entry === "string") {
      return [key, hashIdentifier(entry)] as const
    }

    return [key, sanitizeValue(entry)] as const
  })

  return Object.fromEntries(entries)
}

function hashIdentifier(value: string) {
  let hash = 0
  for (const char of value) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0
  }
  return hash.toString(16).padStart(6, "0").slice(0, 6)
}
